<template>
  <div id="results">
    <sidebar-mobile ref="sidebar" class="sidebar mobile-only" v-if="!this.isExtrasModalOpenOnMobile"></sidebar-mobile>
    <sidebar-desktop class="sidebar desktop-only"></sidebar-desktop>
    <CarList @modalOpen="handleModalOpen" @modalClose="handleModalClose"></CarList>
  </div>
</template>

<script>
import CarList from "@/components/CarList.vue";
import SidebarDesktop from "@/components/SidebarDesktop.vue";
import SidebarMobile from "@/components/SidebarMobile.vue";
import { mapState } from "vuex";

export default {
  name: "results",
  data: function () {
    return {
      isModalOpen: false,
    };
  },
  computed: {
    ...mapState(["searchParameters", "isExtrasModalOpenOnMobile"]),
  },
  methods: {
    openFilters() {
      this.$refs.sidebar.toggleOpen();
    },
    handleModalOpen() {
    this.isModalOpen = true;
    },
    handleModalClose() {
      this.isModalOpen = false;
    }
  },
  mounted() {
    if (
      this.searchParameters.pickupLocation.locationName !==
      this.searchParameters.dropoffLocation.locationName
    ) {
      this.$store.commit("setOneway", true);
    }
    //displays the filter bar on mobile when showing the results
    this.$store.commit('updateIsExtrasModalOpenOnMobile', this.extrasModal);
  },
  components: {
    CarList,
    SidebarMobile,
    SidebarDesktop,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.filter-button {
  margin: 0.75em;
  box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
  border: 0.2px solid $primary-dark;
}

.order-dropdown {
  position: absolute;
  width: inherit;
  margin-top: 10px;
  margin-left: -8px !important;
  border: solid 1px #919191;
  border-radius: 3px;
  background: white;
  * + * {
    border-top: 1px dashed $primary-dark;
  }
  .order-dropdown-item {
    padding: 0.6em 0.3em;
    margin: 0;
    cursor: pointer;
  }
  .order-dropdown-item:hover {
    background: $secondary-color;
  }
}

.sidebar {
  grid-area: sidebar;
  align-self: start;
}

.tool-bar {
  grid-area: toolbar;
  width: 100%;
  max-width: 600px;
  margin: auto;
  margin-bottom: 0.8em;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #919191;
  font-size: 0.8em;
  * + * {
    margin-left: 0.8em;
  }
  i {
    color: #2c3e50;
  }
  .tool-bar__filters {
    background: $grey;
    padding: 0.6em 0.3em;
    border: solid 1px #919191;
    border-radius: 3px;
    width: 40%;
  }
  .tool-bar__order-by {
    background: $grey;
    width: 40%;
    padding: 0.6em 0.3em;
    border: solid 1px #919191;
    border-radius: 3px;
  }
}

@media (max-width: 1120px) {
  .filter-button {
    border: 1px solid #00204e;
    box-sizing: border-box;
    border-radius: 40px !important;
  }
}

@media (min-width: 1120px) {
  #results {
    display: grid;
    grid-template-columns: 314px 1fr 1fr 1fr;
    grid-template-rows: auto;
    grid-auto-rows: minmax(10px, auto);
    grid-column-gap: $standard-margin * 3;
    grid-row-gap: $standard-margin * 3;
    grid-template-areas: "sidebar carlist carlist carlist";
  }
  #car-list {
    grid-area: carlist;
  }
  .filters-desktop {
    grid-area: filters;
    height: fit-content;
  }
  .tool-bar__order-by {
    background: $grey;
    width: 75%;
    padding: 0.6em 0.3em;
    margin: $standard-padding;
    border: solid 1px #919191;
    border-radius: 3px;
  }

  .order-dropdown {
    position: absolute;
    width: 168px;
    margin-top: 10px;
    margin-left: -8px !important;
    border: solid 1px #919191;
    border-radius: 3px;
    background: white;
    * + * {
      border-top: 1px dashed $primary-dark;
    }
    .order-dropdown-item {
      padding: 0.6em 0.3em;
      margin: 0;
      cursor: pointer;
    }
    .order-dropdown-item:hover {
      background: $secondary-color;
      color: $grey;
    }
  }
}
</style>
